import { render, staticRenderFns } from "./Bando33Fase1.vue?vue&type=template&id=fe8f345c&scoped=true"
import script from "./Bando33Fase1.vue?vue&type=script&lang=js"
export * from "./Bando33Fase1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8f345c",
  null
  
)

export default component.exports